import * as React from 'react';
import './Campaign.css';
import { inject, observer } from 'mobx-react';
import * as ReactGA from 'react-ga';
import { AppStore } from '../stores';
import AuthenticationService from '../services/AuthenticationService';
import { IUser } from '../interfaces/IUser';
import Login from '../mindjuiceApp/landingPage/login/Login';
import ForgottenPassword from '../mindjuiceApp/landingPage/forgottenPassword/ForgottenPassword';
import ForgottenPasswordConfirmation from '../mindjuiceApp/landingPage/forgottenPasswordConfirmation/ForgottenPasswordConfirmation';
import ProductService from '../services/ProductService';

export interface IProps {
  appStore?: AppStore;
}

export interface IState {
  showLoginButtons: boolean;
  name: string;
  username: string;
  password: string;
  signupEnabled: boolean;
  loginError: boolean;
  disclaimerAcceepted: boolean;
  showPassword: boolean;
  showPasswordAgain: boolean;
  passwordAgain: string;
  showInfoPage: boolean;
}

@inject('appStore')
@observer
export default class Campaign extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      showLoginButtons: false,
      name: undefined,
      username: undefined,
      password: undefined,
      signupEnabled: false,
      loginError: false,
      disclaimerAcceepted: false,
      showPassword: false,
      showPasswordAgain: false,
      passwordAgain: undefined,
      showInfoPage: false
    }
    document.addEventListener("keyup", ((event) => {
      if (event.keyCode === 13) {
        event.preventDefault();
        if (this.state.signupEnabled) {
          this.signUp();
        }
      }
    }));
  }

  public componentDidMount(): void {
    setTimeout(() => {
      this.setState({ showLoginButtons: true });
    }, 1000);
  }


  private validate(): void {
    if (this.state.username && this.state.password && this.state.name && this.state.disclaimerAcceepted && this.state.password === this.state.passwordAgain) {
      this.setState({ signupEnabled: true });
    } else {
      this.setState({ signupEnabled: false });
    }
  }

  private signUp(): void { // TODO: Implement sign up logic
    if (this.state) {
      this.props.appStore!.loggingIn = true;
      AuthenticationService.signUp(this.state.username, this.state.password, this.state.name).then((user: IUser) => {
        if (user) {
          ReactGA.event({
            category: 'User',
            action: `User signing up for summer campaign`
          });
          const nameParts = this.state.name.split(" ");
          const firstName = nameParts[0] ? nameParts[0] : "";
          const lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
          ProductService.allowAccessToProduct("19067", this.state.username, undefined, "Gratis Enneagrammy Kampagne").then(() => {
            AuthenticationService.createUserInActiveCampaign(firstName, lastName, this.state.username).then((id: string) => {
              AuthenticationService.addTagToActiveCampaginUser(id, "776").then(() => {
                this.props.appStore!.setUser(user);
                this.props.appStore!.loggingIn = false;
                this.setState({ showInfoPage: true });
              });
            });
          });
        } else {
          this.setState({ loginError: true });
          setTimeout(() => {
            this.setState({ loginError: false });
          }, 1000);
        }
      });
    }
  }

  render() {
    return (
      <div className="campaignPage">
        <div className='frontpageBoxContainer'>
          <div className='frontpageIllustration'></div>
          <div className="frontpageBox">
            {this.state.showInfoPage ?
              <div>
                <h1>{window.loc.strings.campaignHeadlineSuccess.toUpperCase()}</h1>
                <div className="frontpageText" dangerouslySetInnerHTML={{ __html: window.loc.strings.campaignSuccessInfo }} />
                {/* <a href="https://dojo.mindjuice.com/tests/19067">
                  <div
                    className="campaignPageBotton"
                    style={{
                      marginLeft: 20,
                      width: "calc(100% - 40px)",
                    }}
                  >
                    {window.loc.strings.webApp.toUpperCase()}
                  </div>
                </a>
                <a href="https://apps.apple.com/us/app/enneagrammy/id1033881087">
                  <div
                    className="campaignPageBotton"
                    style={{
                      marginTop: 20,
                      marginLeft: 20,
                      width: "calc(100% - 40px)",
                    }}
                  >
                    {window.loc.strings.iosApp.toUpperCase()}
                  </div>
                </a> */}
              </div>
              :
              <div>
                <div style={{ marginLeft: 20, fontSize: 17 }}>{window.loc.strings.campaignLabel.toUpperCase()}</div>
                <h1>{window.loc.strings.campaignHeadline.toUpperCase()}</h1>
                <div className="frontpageText" dangerouslySetInnerHTML={{ __html: window.loc.strings.campaignDescription }} />
                <div
                  style={{
                    transform: "translate3d(0, 0, 0)",
                    backfaceVisibility: "hidden",
                    perspective: "1000px",
                    marginTop: 30
                  }}
                >
                  <div
                    className="login"
                    style={{
                      animation: this.state.loginError ? "shake 0.82s cubic-bezier(.36,.07,.19,.97) both" : "none",
                      transform: "translate3d(0, 0, 0)",
                      backfaceVisibility: "hidden",
                      perspective: "1000px",
                    }}
                  >
                    <input
                      type="text"
                      placeholder={window.loc.strings.name}
                      onPaste={() => {
                        setTimeout(() => {
                          this.validate();
                        }, 100);
                      }}
                      onChange={(event: any) => {
                        this.setState({ name: event.target.value }, () => this.validate());
                      }}
                    />
                    <input
                      type="email"
                      placeholder={window.loc.strings.email}
                      onPaste={() => {
                        setTimeout(() => {
                          this.validate();
                        }, 100);
                      }}
                      onChange={(event: any) => {
                        this.setState({ username: event.target.value.toLowerCase() });
                        this.validate();
                      }}
                      autoFocus
                    />
                    <input
                      type={this.state.showPassword ? "text" : "password"}
                      placeholder={window.loc.strings.password}
                      onPaste={() => {
                        setTimeout(() => {
                          this.validate();
                        }, 100);
                      }}
                      onChange={(event: any) => {
                        this.setState({ password: event.target.value }, () => this.validate());
                      }}
                    />
                    <div
                      className='showPasswordButton'
                      style={{
                        marginTop: 165,
                        zIndex: 1,
                        backgroundImage: this.state.showPasswordAgain ? 'url("https://img.icons8.com/fluency-systems-regular/48/invisible.png")' : 'url("https://img.icons8.com/fluency-systems-regular/48/000000/visible--v1.png")'
                      }}
                      onClick={() => this.setState({ showPasswordAgain: !this.state.showPasswordAgain })}
                    />
                    <input
                      type={this.state.showPasswordAgain ? "text" : "password"}
                      placeholder={window.loc.strings.passwordAgain}
                      onPaste={() => {
                        setTimeout(() => {
                          this.validate();
                        }, 100);
                      }}
                      style={{
                        color: this.state.passwordAgain === this.state.password ? "#272727" : "red"
                      }}
                      onChange={(event: any) => {
                        this.setState({ passwordAgain: event.target.value }, () => this.validate());
                      }}
                    />
                    <div
                      className='showPasswordButton'
                      style={{
                        marginTop: 110,
                        backgroundImage: this.state.showPassword ? 'url("https://img.icons8.com/fluency-systems-regular/48/invisible.png")' : 'url("https://img.icons8.com/fluency-systems-regular/48/000000/visible--v1.png")'
                      }}
                      onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                    />
                    <div
                      className={"disclaimer"}
                      style={{
                        color: "#ffffff"
                      }}
                    >
                      <input
                        checked={true}
                        disabled={true}
                        type="checkbox"
                      />
                      {window.loc.strings.signUpForNewsletter}
                    </div>
                    <div
                      className={"disclaimer"}
                      style={{
                        color: "#ffffff"
                      }}
                    >
                      <input
                        checked={this.state.disclaimerAcceepted}
                        type="checkbox"
                        onChange={() => {
                          this.setState({ disclaimerAcceepted: !this.state.disclaimerAcceepted }, () => this.validate());
                        }}
                      />
                      {window.loc.strings.iAcceptThePrivacy} <a href={window.loc.strings.language === "Danish" ? "https://www.dojo.mindjuice.com/privacy-policy-da.html" : "https://www.dojo.mindjuice.com/privacy-policy-en.html"} target="_blank">{window.loc.strings.personalDataPolicy}</a>.
                    </div>
                    {this.props.appStore!.loggingIn ?
                      <div /> // Show spinner
                      :
                      <>
                        <div
                          className="campaignPageBotton"
                          style={{
                            opacity: this.state.signupEnabled ? 1 : 0.5,
                          }}
                          onClick={() => {
                            if (this.state.signupEnabled) {
                              this.signUp();
                            }
                          }}
                        >
                          {window.loc.strings.signUpForCampaign.toUpperCase()}
                        </div>
                        <div
                          className="campaignPageAltBotton"
                          onClick={() => {
                            this.props.appStore!.showingLogin = true;
                          }}>
                          {window.loc.strings.alreadyHaveAnAccount}
                        </div>
                      </>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        {
          this.props.appStore!.showingForgottenPassword &&
          <ForgottenPassword
            buttonColor="#122c43"
          />
        }
        {
          this.props.appStore!.showingForgottenPasswordConfirmation &&
          <ForgottenPasswordConfirmation />
        }
        {
          (this.props.appStore!.loggingIn || this.props.appStore!.loading) &&
          <div className="loading">
            <div className="loader"></div>
          </div>
        }
        {
          this.props.appStore!.showingLogin &&
          <div
            className="mobileFrontpageLoginBoxContainer"
          >
            <div className="mobileFrontpageLoginBox">
              <div
                className="mobileFrontpageLoginBoxCloseButton"
                onClick={() => this.props.appStore!.showingLogin = false}
              />
              <Login
                buttonColor="#122c43"
                loginSuccessful={() => {
                  if (this.props.appStore!.user) {
                    const nameParts = this.props.appStore!.user.name.split(" ");
                    const firstName = nameParts[0] ? nameParts[0] : "";
                    const lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
                    ProductService.allowAccessToProduct("19067", this.props.appStore!.user.username, undefined, "Gratis Enneagrammy Kampagne").then(() => {
                      AuthenticationService.createUserInActiveCampaign(firstName, lastName, this.props.appStore!.user.username).then((id: string) => {
                        AuthenticationService.addTagToActiveCampaginUser(id, "776").then(() => {
                          this.props.appStore!.loggingIn = false;
                          this.setState({ showInfoPage: true });
                        });
                      });
                    });
                  }
                }}
              />
            </div>
          </div>
        }
      </div >
    );
  }
}